class Address {
  static formatAddress (address) {
    const { route, number, complement, district, city, state } = address
    return `${route}, ${number}${complement ? `, ${complement}` : ''} - ${district}, ${city} - ${state}`
  }
}

export default Address
